import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import Tooltip from '../tooltip/Tooltip'

const InputFile = React.forwardRef((props, ref) => {
    const {name, fileName, label, value, description, error, className, ...other} = props

    return <Fragment>
        {label && <span>{label}</span>}
        <Tooltip className={`mb-2 flex flex-col ${className || ''}`} message={error ? error.message : ''} type='error'>
            <label for={name} tabindex="0" className={`input-file flex flex-row items-baseline flex-1 cursor-pointer ${error ? 'has-errors' : ''}`}>
                <span className='btn-yellow w-38 mr-2'>Choose file</span>
                <span className='flex-1'>{fileName || 'No file chosen'}</span>
            </label>
            <input ref={ref} value={value} id={name} name={name} {...other} type={'file'}
                   accept='.png,.jpg,.ico,.svg'
                   className={'hidden'}
            />
            {description && <span className='text-xs text-right'>{description}</span>}
        </Tooltip>

    </Fragment>
})

InputFile.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.string,
    description: PropTypes.string,
    error: PropTypes.object
}

export default InputFile
